import React from "react";
import FeedIn from "../../../components/FramerMotion/FeedIn";
import styles from "./style.module.scss";

const Philosophy = () => {
  return (
    <div className={styles.section}>
      <FeedIn>
        <div className={styles.sectionInner}>
          <h3 className={styles.title}>
            一気通貫だからこそ、
            <br />
            信頼できるモノづくり。
          </h3>
          <p className={styles.description}>
            モノや情報で溢れている今、
            <br />
            ただモノをつくるのではなく、「なぜつくるのか」が問われます。
            <br />
            ミヤザワは開発段階からお客様に寄り添い、
            <br />
            金型製造→試作→量産と一貫することで製品と真摯に向き合い、
            <br />
            あなたの事業を支えます。
          </p>
        </div>
      </FeedIn>
    </div>
  );
};

export default Philosophy;
